import {
    Dialog,
    DialogTitle,
    DialogContent,
    Box,
    IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { AllHistoryFilters } from './filters/AllHistoryFilters';

import { Table } from '../../../../../components/general/table';
import { useHistoryAllData } from './hooks/useHistoryallData';
import { useEffect, useRef } from 'react';
import { buildInteractionUrl } from './shared/urlBuilders';

type Props = {
    open: boolean;
    onClose: () => void;
    identification?: string;
};

export const HistoryAllModal = ({ open, onClose, identification }: Props) => {
    const isFirstRender = useRef(true);

    const {
        rows,
        rowCount,
        loading,
        columns,
        paginationModel,
        setPaginationModel,
        submitFilters,
        resetFilters,
        search,
        enable,
    } = useHistoryAllData({ identification }, 20, false);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        if (open) {
            submitFilters({ identification });
            enable();
        }
    }, [open, identification]);

    const onRowClick = (params: any) => {
        const url = buildInteractionUrl(params.row);
        if (url) window.open(url, '_blank');
    };

    const closeModal = () => {
        onClose();
        resetFilters();
    };

    return (
        <Dialog open={open} onClose={closeModal} maxWidth="xl" fullWidth>
            <DialogTitle
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}
            >
                Histórico de interacción
                <IconButton onClick={closeModal}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <AllHistoryFilters
                    initialValues={{ identification }}
                    identificationDisabled
                    submitting={loading}
                    onSubmit={submitFilters}
                    onSearch={search}
                    onReset={resetFilters}
                />
                <Box mt={2}>
                    <Table
                        rows={rows}
                        columns={columns}
                        loading={loading}
                        rowCount={rowCount}
                        paginationModel={paginationModel}
                        onPaginationModelChange={setPaginationModel}
                        onRowClick={onRowClick}
                    />
                </Box>
            </DialogContent>
        </Dialog>
    );
};
